export default __webpack_public_path__ + "static/media/GodrejBhavaneBook.24605124.png";